import type { ReactNode } from 'react';
import type { FooterActionsType } from '@interstate/components/FooterActions';
import { Button } from '@interstate/components/Button';
import { ChevronLeftIcon } from '@interstate/components/Icons/ChevronLeftIcon';
import { SlideOutHeader, type SlideOutHeaderType } from './SlideOutHeader';
import { SlideOutWithFixedFooter } from '@makemydeal/dr-dash-components';

export const SlideOutWrapper = ({
    children,
    isOpen,
    onClose,
    onBack,
    panelWidth,
    testId,
    title,
    footer,
    vehicleOverride
}: {
    children: NonNullable<ReactNode> | undefined;
    isOpen: boolean;
    onClose: () => void;
    onBack?: () => void;
    panelWidth?: string;
    testId: string;
    title: ReactNode | string;
    footer?: FooterActionsType;
    vehicleOverride?: SlideOutHeaderType['vehicleOverride'];
}) => {
    const header = onBack ? (
        <>
            <Button buttonStyle="aux" size="small" startIcon={<ChevronLeftIcon />} onClick={onBack} data-testid={`${testId}-back`}>
                Back
            </Button>
            <SlideOutHeader title={title} vehicleOverride={vehicleOverride} />
        </>
    ) : (
        <SlideOutHeader title={title} vehicleOverride={vehicleOverride} />
    );

    return (
        <SlideOutWithFixedFooter
            header={header}
            footer={footer}
            show={isOpen}
            onHide={onClose}
            position="right"
            panelWidth={panelWidth}
            data-testid={testId}
        >
            {children}
        </SlideOutWithFixedFooter>
    );
};
